import { handleGetData } from '../../Api';

// A galeria e a página do álbum leem as mesmas duas coisas: a página
// (`pagina-galeria-de-fotos`, os textos) e todos os álbuns publicados. A lista
// inteira vem de uma vez -- são ~100 álbuns, e a busca, o filtro por ano, a
// contagem e "outros álbuns" precisam dela toda. Fica guardada enquanto o
// visitante anda entre a galeria e os álbuns, para não buscar de novo.
let emAndamento = null;

const buscarTodos = async (token, schema) => {
  const itens = [];
  for (let pular = 0; ; pular += 200) {
    const r = await handleGetData(
      token,
      `api/content/copasul/${schema}/?$top=200&$skip=${pular}&$orderby=data/data/iv desc`,
    );
    const lote = r?.data?.items || [];
    itens.push(...lote);
    if (!lote.length || itens.length >= (r?.data?.total ?? 0)) return itens;
  }
};

const paraAlbum = (item) => {
  const d = item.data || {};
  const fotos = d.fotos?.iv || [];
  return {
    id: item.id,
    titulo: d.titulo?.iv || '',
    data: d.data?.iv || '',
    descricao: d.descricao?.iv || '',
    endereco: d.endereco?.iv || '',
    fotos,
    capa: d.capa?.iv?.[0] || fotos[0],
  };
};

export const carregarGaleria = (token) => {
  if (!emAndamento) {
    emAndamento = Promise.all([
      handleGetData(token, 'api/content/copasul/pagina-galeria-de-fotos/').then(
        (r) => r?.data?.items?.[0]?.data || {},
      ),
      buscarTodos(token, 'album-de-fotos'),
    ])
      .then(([pagina, itens]) => {
        const campo = (nome) => pagina[nome]?.iv || {};
        return {
          topo: campo('topo'),
          albuns: campo('albuns'),
          album: campo('album'),
          faixaFinal: pagina.faixaFinal?.iv || null,
          metadados: campo('metadados'),
          // sem endereço o álbum não tem como abrir: fica fora da galeria
          lista: itens.map(paraAlbum).filter((a) => a.endereco),
        };
      })
      .catch((e) => {
        emAndamento = null;
        throw e;
      });
  }
  return emAndamento;
};

// O campo Data do Squidex chega como meia-noite UTC ("2026-10-12T00:00:00Z").
// Lido no fuso de Brasília, vira 21h do dia anterior -- era por isso que os
// editores somavam um dia. Aqui a data é formatada em UTC, como a data pura
// que ela é.
const formatoData = new Intl.DateTimeFormat('pt-BR', {
  day: 'numeric',
  month: 'long',
  year: 'numeric',
  timeZone: 'UTC',
});

export const dataPorExtenso = (iso) => (iso ? formatoData.format(new Date(iso)) : '');
export const anoDe = (iso) => (iso ? iso.slice(0, 4) : '');

// Rótulos de interface: são sempre os mesmos, então ficam aqui e não no
// Squidex. No Squidex fica só o que é conteúdo (títulos, textos, destaques).
export const ROTULOS = {
  destaque: 'Em destaque',
  chapeuLista: 'Galeria de fotos',
  busca: 'Busque por um evento ou momento…',
  todos: 'Todos',
  outrosAnos: 'Outros anos',
  album: ['álbum', 'álbuns'],
  foto: ['foto', 'fotos'],
  verAlbum: 'Ver álbum',
  carregarMais: 'Carregar mais',
  vazio: 'Nenhum álbum nesta seleção.',
  limpar: 'Limpar filtros',
  fim: 'Você chegou ao fim da seleção',
  dica: 'Clique para ampliar · Use as setas para navegar',
  compartilhar: 'Compartilhar',
  ajuda: '← → Navegar · Esc Fechar · + Ampliar',
  outrosChapeu: 'Galeria de fotos',
};

// "1 álbum", "4 álbuns".
export const contagem = (n, [um, varios]) => `${n} ${n === 1 ? um : varios}`;

// Busca sem acento e sem maiúscula: "fiacao" acha "Fiação".
export const semAcento = (texto = '') =>
  texto.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();

// Os 3 em destaque: o principal e os outros 2 escolhidos no Squidex. Vaga sem
// escolha (ou com álbum que saiu do ar) é preenchida pelo mais recente que
// ainda não está em destaque.
export const destaquesDe = (galeria) => {
  const { destaquePrincipal = [], destaquesSecundarios = [] } = galeria.albuns;
  const achar = (id) => galeria.lista.find((a) => a.id === id);
  const vagas = [destaquePrincipal[0], destaquesSecundarios[0], destaquesSecundarios[1]].map(achar);
  const sobra = galeria.lista.filter((a) => !vagas.includes(a));
  return vagas.map((a) => a || sobra.shift()).filter(Boolean);
};

// Título e descrição da aba e do Google, devolvendo os anteriores ao sair.
export const aplicarMetadados = ({ titulo, descricao }) => {
  const tituloAntes = document.title;
  const meta = document.querySelector('meta[name="description"]');
  const descricaoAntes = meta?.getAttribute('content');
  if (titulo) document.title = titulo;
  if (meta && descricao) meta.setAttribute('content', descricao);
  return () => {
    document.title = tituloAntes;
    if (meta && descricaoAntes != null) meta.setAttribute('content', descricaoAntes);
  };
};
